// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"4":"4187507b3111f2d0a3f7","20":"cffaf2efaa19cc327ac5","700":"cffaf2efaa19cc327ac5","799":"8b28f8e8aa5bb21b3f5d","922":"6f7bb764fb3fad4a0c7e"}[chunkId] + ".css";
};